const submit = document.getElementById('form-submit');

submit.addEventListener('click', () => {
  let localStorageData = JSON.stringify({
    keywordName: 'popupFormSubmitted',
  });

  window.localStorage.setItem('popupFormSubmitted', localStorageData);
});
